module.exports = __webpack_public_path__ + "img/my-account-arrow-down.2ffb555a.svg";